import { CompanyRole } from "model/User";
import { useAuthStore } from "stores/authStore/authStore";
import { ClockStamp } from "web-apps/company/components/clockStamp/clockStamp.component";
import { ClockStampAccessPromptModal } from "web-apps/company/components/clockStamp/clockStampAccessPromptModal.component";

export const ClockStampPage = (): JSX.Element | null => {
  const [authState] = useAuthStore();

  if (authState.user == null) return null;
  if (authState.user.role === CompanyRole.COMPANY_TIMESTAMP) {
    return <ClockStamp />;
  }

  return <ClockStampAccessPromptModal />;
};
